import type { CareerHubBrand } from 'src/types';

const displayBrands: Record<CareerHubBrand, string> = {
  seek: 'SEEK',
  jobsdb: 'Jobsdb',
  jobstreet: 'Jobstreet',
};

export const useDisplayBrand = (brand: CareerHubBrand): string =>
  displayBrands[brand];
